import snakecaseKeys from 'snakecase-keys';
import { restClient } from '../client';
import { UpdateMatchPreferencesInput } from './onboarding';


export type ConfirmRematchingInput = {
  oldMatchId: string;
  timeStart: string;
  providerId: string;
  details?: string;
  rematchingReasons?: string[];
  newAddress?: {
    line_1: string;
    line_2: string;
    city: string;
    stateId: string;
    zip: string;
  };

  matchPreferences?: UpdateMatchPreferencesInput;
};


export type ConfirmRematchingOutput = {
  success: boolean;
  error?: string;
};


export const confirmRematching = (data: ConfirmRematchingInput) => {
  return restClient.request<ConfirmRematchingOutput>('/api/v1/onboarding/rematching/confirm', { method: 'POST', data: snakecaseKeys(data, { deep: true }) });
};


export type ConfirmMatchingOutput = {
  data: {
    success: boolean;
  };
};


export type ConfirmMatchingInput = {
  timeStart: string;
  providerId: string;

  matchPreferences?: UpdateMatchPreferencesInput;
};


export const confirmMatching = (data: ConfirmMatchingInput) => {
  return restClient.request<ConfirmMatchingOutput>('/api/v1/onboarding/matching/confirm', { method: 'POST', data: snakecaseKeys(data) });
};
